import { render, staticRenderFns } from "./CreatePartnerProject.vue?vue&type=template&id=7b928378&"
import script from "./CreatePartnerProject.vue?vue&type=script&lang=ts&"
export * from "./CreatePartnerProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports